/**
 * `affiliate_clicks.id`(uuid) 형태 판정 — **클라이언트·서버 공용** 정본.
 *
 * tracking.ts 는 node:crypto 를 쓰는 서버 전용 모듈이라 클라이언트 코드(설치 페이지,
 * Install Referrer 파서)가 import 할 수 없다. 같은 판정을 두 벌 들지 않도록 판정은
 * 여기 하나만 두고 tracking.ts 가 재노출한다.
 *
 * 쿠키·URL·리퍼러에서 온 값을 그대로 `id.in.(...)` 필터에 넣으면 형태가 어긋난 값
 * 하나가 쿼리 전체를 22P02 로 떨어뜨린다(= 귀속이 통째로 유실된다). 넣기 전에 본다.
 */

const CREW_UUID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function isCrewClickId(value: unknown): value is string {
  return typeof value === "string" && CREW_UUID_PATTERN.test(value);
}
